import type { PublicEventBadge } from "../types/public";

type Size = "sm" | "md" | "lg";

export function EventBadgeStamp({ badge, size = "md", title: titleOverride }: { badge: PublicEventBadge; size?: Size; title?: string }) {
  const short = String(badge?.short ?? "?").trim() || "?";
  const color = typeof badge?.color === "string" && badge.color.trim() ? badge.color : "#78909c";
  const cls = size === "sm" ? "event-badge-stamp sm" : size === "lg" ? "event-badge-stamp lg" : "event-badge-stamp";
  return (
    <span className={cls} style={{ backgroundColor: color, color: badge?.fg ?? "#fff" }} title={titleOverride ?? badge?.label ?? short}>
      {short}
    </span>
  );
}
